module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"read_more_message":"read more","read_less_message":"read less"},"es":{"read_more_message":"ver más","read_less_message":"ver menos"}}')
  delete Component.options._Ctor
}
